export const negotiationsListTableColumns = [
  { label: 'Código', value: 'number' },
  { label: 'Status', value: 'status' },
  { label: 'Estabelecimento', value: 'establishment_company' },
  { label: 'Data da solicitação', value: 'created_at' },
  { label: 'Data da efetivação', value: 'accepted_at' },
  { label: 'Valido por mais', value: 'due_for' },
  { label: 'Ações', value: 'actions' },
];
